import { css } from "styled-components";
import { CarouselSlide, CarouselTrigger, CarouselViewport } from "../../../../components/Carousel";
import { CTA } from "../../../../components/CTA";
import { Icon } from "../../../../components/Icon";
import { Image } from "../../../../components/Image";
import { Availability } from "../../components/Availability";
import { BackdropBackground, BackdropForeground } from "../../../../components/Backdrop";
import { HeaderBar } from "../../components/HeaderBar";
import { MastheadCarousel } from "../../components/MastheadCarousel";
import { hideOnTouchDevices } from "../../../../skins/shared/mixins/mediaQueries";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
const bladeGutter = "35px";
const contentGutter = "20px";
export const leagueClientSkin = (chroma) => css `
  & {
    --carousel-slide-height: 185px;
    --bladeHeader-height: 60px;

    max-height: 1300px;
    min-height: 800px;
    height: 100vh;
    margin: 0 auto;
    padding: 0;
    transition: max-height 0.5s ease-in-out;

    .layout {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: grid;
      grid-template-columns: repeat(1fr);
      grid-template-rows: var(--bladeHeader-height) 1fr 100px 255px;
      grid-column-gap: 0;
      grid-row-gap: 0;
    }
  }

  ${HeaderBar} {
    grid-area: 1 / 1 / 1 / 2;
    margin: 0;
    position: relative;
    overflow: visible;
    display: flex;
    justify-content: space-between;
    align-content: center;
    flex-direction: row;

    .logo {
      display: flex;
      width: 100%;
      max-width: 35%;
      min-width: 85px;
      height: 85px;
      align-items: flex-start;
      position: relative;
      top: var(--bladeHeader-height);
      left: ${bladeGutter};
      ${Image} {
        height: auto;
        object-fit: contain;
      }
    }

    .links {
      display: flex;
      align-self: center;
      justify-self: flex-end;
      justify-content: flex-end;
      margin: 0 ${bladeGutter};
      align-items: center;
      gap: clamp(5px, 2vw, 10px);

      ${CTA} {
        text-align: center;
        vertical-align: bottom;
        line-height: 22px;
        letter-spacing: -0.02em;
        white-space: nowrap;
        margin-top: 0;
      }

      a.secondary {
        line-height: 22px;
        ${chroma.typography.label}
        padding-right: ${bladeGutter};
        letter-spacing: -0.02em;
        text-decoration: none;
        min-width: 110px;
        padding: 5px 1.3em;
        color: ${chroma.palette.gold2};
        text-shadow:
          0 0 1px rgb(0 0 0 / 50%),
          0 0 2px rgb(0 0 0 / 80%),
          0 0 4px rgb(0 0 0 / 100%);

        ${Icon} {
          height: 0.7em;
          width: 0.7em;
          background-color: ${chroma.palette.gold2};
        }
      }
    }
  }

  ${BackdropForeground},
  ${BackdropBackground} {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: 50%;
    }
  }
  ${BackdropBackground} {
    filter: opacity(0.3) blur(10px);
  }
  ${BackdropForeground} {
    padding-top: clamp(0px, 20vw, 160px);
    display: flex;
    flex-direction: row;
    justify-content: center;

    > img {
      height: 100%;
      width: auto;
      object-fit: cover;
      object-position: 50% 100%;
    }
  }

  ${MastheadCarousel} {
    position: absolute;
    bottom: 0;
    padding: 0;
    margin: 0;
    width: 100%;

    ${CarouselTrigger} {
      ${hideOnTouchDevices}
      position: absolute;
      bottom: ${contentGutter};
      width: calc(${bladeGutter} - 4px);
      height: var(--carousel-slide-height);
      background-color: ${chroma.palette.almostBlack};

      /* keep children centered */
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        /* background: ; */
      }

      &:disabled {
        opacity: 0.25;
      }

      &.prev {
        left: 0;
      }

      &.next {
        right: 0;
      }
    }
    ${CarouselViewport} {
      padding: ${contentGutter} ${bladeGutter};
    }
    ${CarouselSlide} {
      cursor: pointer;
      height: var(--carousel-slide-height);
      min-width: 330px;
      aspect-ratio: 16 / 9;
      align-self: flex-end;
      transition:
        height 0.3s ease-in-out,
        width 0.3s ease-in-out,
        transform 0.3s ease-in-out;
      margin: 0 calc(${contentGutter} / 2) 0 0;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        z-index: 2;
      }
    }
  }

  ${Availability} {
    margin: calc(${contentGutter} / 2) ${bladeGutter};
    position: absolute;
    bottom: calc(var(--carousel-slide-height) + (${contentGutter} * 2));
    right: 0;
    display: flex;
    align-items: center;
    justify-content: left;
    min-height: 90px;
    border: 1px solid ${chroma.palette.gold3};
    color: ${chroma.palette.gold2};
    padding: 0 16px;

    /* TODO: use typography from chroma */
    font-size: 14px;
    font-weight: 500;
    min-width: 300px;
    max-width: calc(100% - (${bladeGutter} * 2));

    > div {
      &::after {
        content: "";
        display: block;
        position: absolute;
        background-color: ${chroma.palette.almostBlack};
        right: 32px;
        bottom: calc(50% - 5px);
        width: 10px;
        height: 10px;
      }

      > fieldset {
        --icon-padding: 8px;
        --icon-size: 24px;

        border: none;

        legend {
          ${chroma.typography.label};
          color: ${chroma.palette.gold3};
          padding: var(--icon-padding);
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          ${textUppercaseMixin}

          li {
            height: calc(var(--icon-size) + (2 * var(--icon-padding)));
            width: calc(var(--icon-size) + (2 * var(--icon-padding)));
            padding: var(--icon-padding);
          }

          a {
            color: ${chroma.palette.gold3};
            display: inline-block;
            height: var(--icon-size);
            width: var(--icon-size);
            line-height: var(--icon-size);
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map